export const cardBackground = "#f0f0f0";
